export default __webpack_public_path__ + "static/media/alert_green.840cf260.svg";